import { initSite } from 'site.js';

const initDOM = () => {
    Promise.all([
        import(/* webpackChunkName: "jQuery" */ 'jquery'),
        import(/* webpackChunkName: "bootstrap" */ 'bootstrap'),
    ]).then(([{ default: $ }]) => {
        $('body').removeClass('preload');
    });
};
const initTagWizard = () => {
    if (tagWizard) {
        Promise.all([
            import(/* webpackChunkName: "React" */ 'react'),
            import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
            import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
            import(/* webpackChunkName: "Store" */ 'store/store'),
            import(/* webpackChunkName: "SuggestedProductList" */ 'containers/SuggestedProductListContainer'),
            import(/* webpackChunkName: "ProductTagWizard" */ 'containers/ProductTagWizardContainer'),
            import(/* webpackChunkName: "TagWizardActions" */ 'actions/tagWizardActions'),
            import(/* webpackChunkName: "Reactl10n" */ 'react-l10n'),
            import(/* webpackChunkName: "MainLanguage" */ 'lang/main'),
        ]).then(
            ([
                { default: React },
                { default: ReactDOM },
                ReactRedux,
                Store,
                { default: SuggestedProductList },
                { default: ProductTagWizard },
                TagWizardActions,
                { LocalizationProvider },
                { getResources },
            ]) => {
                const { Provider } = ReactRedux;
                const { store } = Store;
                const { initializeScreenHistory } = TagWizardActions;

                store.dispatch(initializeScreenHistory());

                ReactDOM.render(
                    <LocalizationProvider resources={getResources()}>
                        <Provider store={store}>
                            <ProductTagWizard />
                        </Provider>
                    </LocalizationProvider>,
                    tagWizard
                );

                if (suggestedProductSlider) {
                    ReactDOM.render(
                        <LocalizationProvider resources={getResources()}>
                            <Provider store={store}>
                                <SuggestedProductList />
                            </Provider>
                        </LocalizationProvider>,
                        suggestedProductSlider
                    );
                }
            }
        );
    }
};
const initEditor = () => {
    if (editor) {
        Promise.all([
            import(/* webpackChunkName: "React" */ 'react'),
            import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
            import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
            import(/* webpackChunkName: "Store" */ 'store/store'),
            import(/* webpackChunkName: "Editor" */ 'containers/LegacyEditorContainer'),
        ]).then(
            ([
                { default: React },
                { default: ReactDOM },
                ReactRedux,
                Store,
                { default: Editor },
            ]) => {
                const { Provider } = ReactRedux;
                const { store } = Store;

                ReactDOM.render(
                    <Provider store={store}>
                        <Editor />
                    </Provider>,
                    editor
                );
            }
        );
    }
};

import(/* webpackChunkName: "Banner" */ 'dom/banner').then((Banner) => Banner.binds());
import(/* webpackChunkName: "Field" */ 'dom/field').then((Field) => Field.binds());
import(/* webpackChunkName: "FieldAddress" */ 'dom/field--address').then((FieldAddress) => FieldAddress.binds());
import(/* webpackChunkName: "FieldColorPicker" */ 'dom/field--colorpicker').then((FieldColorPicker) => FieldColorPicker.binds());
import(/* webpackChunkName: "FieldDatepicker" */ 'dom/field--datepicker').then((FieldDatepicker) => FieldDatepicker.binds());
import(/* webpackChunkName: "FieldDropzone" */ 'dom/field--dropzone').then((FieldDropzone) => FieldDropzone.binds());
import(/* webpackChunkName: "FieldSelectize" */ 'dom/field--selectize').then((FieldSelectize) => FieldSelectize.binds());
import(/* webpackChunkName: "FieldSearchSupplier" */ 'dom/field--search-supplier').then((FieldSearchSupplier) => FieldSearchSupplier.binds());
import(/* webpackChunkName: "Form" */ 'dom/form').then((Form) => Form.binds());
import(/* webpackChunkName: "Googlemap" */ 'dom/googlemap').then((Googlemap) => Googlemap.binds());
import(/* webpackChunkName: "Loading" */ 'dom/loading').then((Loading) => Loading.binds());
// import(/* webpackChunkName: "Login" */ 'dom/login').then((Login) => Login.binds());
import(/* webpackChunkName: "Menu" */ 'dom/menu').then((Menu) => Menu.binds());
import(/* webpackChunkName: "Modal" */ 'dom/modal').then((Modal) => Modal.binds());
import(/* webpackChunkName: "ProductsGallery" */ 'dom/products-gallery').then((ProductsGallery) => ProductsGallery.binds());
import(/* webpackChunkName: "Products" */ 'dom/products').then((Products) => Products.binds());
import(/* webpackChunkName: "Sections" */ 'dom/sections').then((Sections) => Sections.binds());
// import(/* webpackChunkName: "Sidebar" */ 'dom/sidebar').then((Sidebar) => Sidebar.binds());
import(/* webpackChunkName: "Sidemenu" */ 'dom/sidemenu').then((Sidemenu) => Sidemenu.binds());
import(/* webpackChunkName: "Slider" */ 'dom/slider').then((Slider) => Slider.binds());
import(/* webpackChunkName: "Window" */ 'dom/window').then((Window) => Window.binds());
import(/* webpackChunkName: "Cart" */ 'dom/cart').then((Cart) => Cart.binds());
import(/* webpackChunkName: "Features" */ 'dom/features').then((Features) => Features.binds());
import(/* webpackChunkName: "Testimonials" */ 'dom/testimonials').then((Testimonials) => Testimonials.binds());
import(/* webpackChunkName: "Locations" */ 'dom/locations').then((Locations) => Locations.binds());
import(/* webpackChunkName: "Switcher" */ 'dom/switcher').then((Switcher) => Switcher.binds());
import(/* webpackChunkName: "Card" */ 'dom/card').then((Card) => Card.binds());
import(/* webpackChunkName: "Setup" */ 'dom/setup').then((Setup) => Setup.binds());
import(/* webpackChunkName: "Search" */ 'dom/search').then((Search) => Search.binds());
import(/* webpackChunkName: "ProductsSlider" */ 'dom/products-slider').then((ProductsSlider) => ProductsSlider.binds());
import(/* webpackChunkName: "ButtonPrint" */ 'dom/button-print').then((ButtonPrint) => ButtonPrint.binds());
import(/* webpackChunkName: "WebstoreConfigurator" */ 'dom/webstore-configurator').then((WebstoreConfigurator) => WebstoreConfigurator.binds());
import(/* webpackChunkName: "StoreLocator" */ 'dom/store-locator').then((StoreLocator) => StoreLocator.binds());
import(/* webpackChunkName: "CustomDropdown" */ 'dom/custom-dropdown').then((CustomDropdown) => CustomDropdown.binds());
import(/* webpackChunkName: "Chart" */ 'dom/chart').then((Chart) => Chart.binds());
import(/* webpackChunkName: "MobileFloater" */ 'dom/mobile-floater').then((MobileFloater) => MobileFloater.binds());
import(/* webpackChunkName: "PreRemover" */ 'dom/pre-remover').then((PreRemover) => PreRemover.binds());
import(/* webpackChunkName: "HeaderRibbon" */ 'dom/header-ribbon').then((HeaderRibbon) => HeaderRibbon.binds());
import(/* webpackChunkName: "Locale" */ 'dom/locale').then((Locale) => Locale.binds());
import(/* webpackChunkName: "Registration" */ 'dom/registration').then((Registration) => Registration.binds());
import(/* webpackChunkName: "CancelEditOrder" */ 'dom/cancel-edit-order').then((CancelEditOrder) => CancelEditOrder.binds());

import(/* webpackChunkName: "Product" */ 'dom/components/product').then((Product) => Product.binds());

const tagWizard = document.getElementById('tag-wizard');
const suggestedProductSlider = document.getElementById('suggested-products-slider');
const editor = document.getElementById('editor');

initDOM();
initTagWizard();
if (!tagWizard) {
    initEditor();
}
initSite();
